import { useTenant as useTenantBase } from '../contexts/TenantContext';
import { TenantConfig, CemeteryLocation } from '../types/tenant';

/**
 * Hook for easy access to tenant data throughout the application
 */
export function useTenant() {
  const { tenant, isLoading, error, isAdminMode, isPreviewMode, previewCemetery, refetch, enterPreviewMode, exitPreviewMode } = useTenantBase();

  return {
    tenant,
    isLoading,
    error,
    isAdminMode,
    isPreviewMode,
    previewCemetery,
    refetchTenant: refetch,
    enterPreviewMode,
    exitPreviewMode,
    
    // Computed properties for convenience
    tenantName: tenant?.displayName || tenant?.name || 'Cemetery',
    primaryColor: tenant?.branding?.primaryColor || '#EA6D2C',
    secondaryColor: tenant?.branding?.secondaryColor || '#F5F1E8',
    logoUrl: tenant?.branding?.logoUrl,
    
    // Helper methods
    isFeatureEnabled: (feature: keyof TenantConfig['features']) => {
      return tenant?.features[feature] ?? true;
    },
    
    getMainLocation: (): CemeteryLocation | null => {
      const locations = []; // This should come from context when implemented
      return locations.find(location => location.isMainLocation) || locations[0] || null;
    },
    
    getContactPhone: (): string => {
      return tenant?.contact?.phone || '(03) 8359 0111';
    },
    
    getContactEmail: (): string => {
      return tenant?.contact?.email || 'info@cemetery.com.au';
    },
    
    getEmergencyPhone: (): string => {
      return tenant?.contact?.emergencyPhone || tenant?.contact?.phone || '(03) 8359 0111';
    },
  };
}